import type { CertGenParams } from '@yandex-int/k-common';

import { intoHtml } from '../../utils/html';

type AcceptedSlugs = 'StudentDiagInfAutumn2023' | 'StudentDiagInfSpring2024' | 'StudentDiagInfAutumn2024';

export const StudentDiagInf = ({
    school_name: schoolName,
    first_name: firstName,
    middle_name: middleName,
    last_name: lastName,
    slug = 'StudentDiagInfAutumn2023',
}: CertGenParams & { slug?: AcceptedSlugs }) => {
    const { bg, event, date } =
        {
            StudentDiagInfAutumn2023: {
                bg: 'https://e7n.s3.yandex.net/static/certificates/2022-autumn-diag-inf/back.png',
                event: 'за участие в осенней диагностике\nучеников по информатике',
                date: '31 октября 2023 года',
            },
            StudentDiagInfSpring2024: {
                bg: 'https://avatars.mds.yandex.net/get-schoolbook-images/5519467/dLfHRKTR7_4bSsYJxYBIZ/orig',
                event: 'за участие в весенней диагностике\nучеников по информатике',
                date: '30 апреля 2024 года',
            },
            StudentDiagInfAutumn2024: {
                bg: 'https://avatars.mds.yandex.net/get-schoolbook-images/5623482/F9dATAlphSrey8hGSW_oG/orig',
                event: 'за проведение осенней диагностики\nдля учеников 5–11-х классов',
                date: '21 октября 2024 года',
            },
        }[slug] || {};

    return intoHtml`<!DOCTYPE html>
    <html lang="ru">
    <head>
        <title>Благодарственное письмо за диагностику в Информатике</title>
        <meta http-equiv="Content-Type" content="text/html; charset=utf-8"/>
        <meta name="viewport" content="width=device-width, initial-scale=1.0"/>
        <style>
            @font-face {
                font-family: 'YS Text';
                src: url('https://yastatic.net/s3/home/fonts/ys/1/text-light.woff2') format('woff2'),
                url('https://yastatic.net/s3/home/fonts/ys/1/text-light.woff') format('woff');
                font-weight: 300;
                font-style: normal;
            }

            @font-face {
                font-family: 'YS Text';
                src: url('https://yastatic.net/s3/home/fonts/ys/1/text-regular.woff2') format('woff2'),
                url('https://yastatic.net/s3/home/fonts/ys/1/text-regular.woff') format('woff');
                font-weight: 400;
                font-style: normal;
            }

            @font-face {
                font-family: 'YS Text';
                src: url('https://yastatic.net/s3/home/fonts/ys/1/text-medium.woff2') format('woff2'),
                url('https://yastatic.net/s3/home/fonts/ys/1/text-medium.woff') format('woff');
                font-weight: 500;
                font-style: normal;
            }

            @font-face {
                font-family: 'YS Text';
                src: url('https://yastatic.net/s3/home/fonts/ys/1/text-bold.woff2') format('woff2'),
                url('https://yastatic.net/s3/home/fonts/ys/1/text-bold.woff') format('woff');
                font-weight: bold;
                font-style: normal;
            }

            @font-face {
                font-family: 'YS Display';
                font-weight: bold;
                font-style: normal;
                font-stretch: normal;

                src: url('//yastatic.net/s3/home/fonts/ys/1/display-bold.woff2') format('woff2'),
                 url('//yastatic.net/s3/home/fonts/ys/1/display-bold.woff') format('woff');
            }

            @font-face {
                font-family: 'YS Display';
                font-weight: 800;
                font-style: normal;
                font-stretch: normal;

                src: url('//yastatic.net/s3/home/fonts/ys/1/display-heavy.woff2') format('woff2'),
                url('//yastatic.net/s3/home/fonts/ys/1/display-heavy.woff') format('woff');
            }

            @page {
                size: 210mm 297mm;
                margin: 0;
                padding: 0;
            }

            @media print {
                html,
                body {
                    width: 210mm;
                    height: 297mm;

                    box-sizing: border-box;
                }
            }

            html {
                position: relative;

                margin: 0;
                padding: 0;

                --background-color: #ffffff;
                --text-color: #000000
            }

            body {
                margin: 0;

                color: var(--text-color);

                font-family: 'YS Text', sans-serif;
            }

            .page {
                position: relative;

                overflow: hidden;

                box-sizing: border-box;

                width: 210mm;
                height: 297mm;

                background: var(--background-color);

                page-break-after: always;
            }

            .page__background {
                position: absolute;

                width: 100%;
                height: 100%;

                overflow: hidden;

                display: flex;

                z-index: 1;
            }

            .page__content {
                position: relative;
                z-index: 2;

                height: 100%;
                width: 100%;
            }

            .content {
                box-sizing: border-box;

                display: flex;

                z-index: 2;
            }

            .page__rectangle {
                overflow: hidden;

                position: relative;

                height: 100%;
                width: calc(210 / 595 * 196mm);

                background-color: #FFB1CD;
            }

            .page__paragraph {
                position: absolute;

                top: calc(297 / 842 * 34mm);
            }

            .paragraph {
                width: 100%;
                height: 100%;
            }

            .page__paragraph_white {
                left: calc(297 / 842 * 40mm);

                width: calc(210 / 595 * 200mm);
                height: calc(297 / 842 * 495mm);
            }

            .page__paragraph_purple {
                left: calc(297 / 842 * 40mm);

                width: calc(210 / 595 * 200mm);
                height: calc(297 / 842 * 495mm);
            }

            .page__pc {
                position: absolute;

                bottom: calc(297 / 842 * 140mm);
                left: calc(210 / 595 * 32mm);;

                width: calc(210 / 595 * 200mm);
                height: calc(297 / 842 * 88mm);
            }

            .pc {
                width: 100%;
                height: 100%;
            }

            .page__dots {
                position: absolute;

                bottom: calc(297 / 842 * -86mm);
                left: calc(210 / 595 * -166mm);

                width: calc(210 / 595 * 388mm);
            }

            .dots {
                width: 100%;
                height: 100%;
            }

            .page__line {
                position: absolute;

                height: 297mm;
                width: 210mm;
            }

            .line {
                width: 100%;
                height: 100%;
            }

            .content {
                display: flex;
                flex-direction: column;

                width: calc(210 / 595 * 240mm);

                margin-left: calc(210 / 595 * 311mm);
                margin-top: calc(297 / 842 * 34mm);

                color: var(--text-color);
            }

            .content__logo {
                width: calc(210 / 595 * 168mm);
                height: calc(297 / 842 * 32mm);
            }

            .logo {
                width: 100%;
            }

            .content__title {
                height: calc(297 / 842 * 52mm);;

                margin-top: calc(297 / 842 * 48mm);

                font-family: 'YS Display', 'Arial', sans-serif;
                font-weight: 500;
                font-size: 22pt;
                line-height: 24pt;
                text-transform: uppercase;
            }

            .content__subtitle {
                font-family: 'YS Text', 'Arial', sans-serif;
                font-style: normal;
                font-weight: 400;
                font-size: 12pt;
                line-height: 130%;
                white-space: pre-wrap;
            }

            .content__personal-info {
                margin-top: calc(297 / 842 * 48mm);
            }

            .personal-info {
                display: flex;
                flex-direction: column;

                height: calc(297 / 842 * 166mm);
            }

            .personal-info__name {
                font-family: 'YS Display', 'Arial', sans-serif;
                font-weight: 700;
                font-size: 22pt;
                line-height: 120%;
            }

            .personal-info__school {
                margin-top: calc(297 / 842 * 8mm);

                font-family: 'YS Text', 'Arial', sans-serif;
                font-style: normal;
                font-weight: 400;
                font-size: 12pt;
                line-height: 130%;
            }

            .content__description {
                margin-top: calc(297 / 842 * 48mm);
            }

            .description {
                display: flex;
                flex-direction: column;

                height: calc(297 / 842 * 112mm);
            }

            .description__title {
                font-family: 'YS Display', 'Arial', sans-serif;
                font-weight: 500;
                font-size: 18pt;
                line-height: 120%;
            }

            .description__text {
                margin-top: calc(297 / 842 * 8mm);

                font-family: 'YS Text', 'Arial', sans-serif;
                font-style: normal;
                font-weight: 400;
                font-size: 12pt;
                line-height: 130%;
            }

            .footer {
                position: absolute;
                bottom: calc(297 / 842 * 65mm);

                display: flex;
                flex-direction: column;
            }

            .person {
                display: flex;
                flex-direction: column;
            }

            .person__name {
                font-family: 'YS Text', 'Arial', sans-serif;
                font-weight: 500;
                font-size: 13pt;
                line-height: 15pt;
            }

            .person__position {
                margin-top: calc(297 / 842 * 8mm);

                font-family: 'YS Text', 'Arial', sans-serif;
                font-weight: 400;
                font-size: 10pt;
                line-height: 11pt;
            }

            .footer__date {
                margin-top: calc(297 / 842 * 72mm);

                font-family: 'YS Text', 'Arial', sans-serif;
                font-weight: 400;
                font-size: 13pt;
                line-height: 130%;
            }

            .footer__seal {
                position: absolute;

                height: calc(297 / 842 * 130mm);
                width: calc(210 / 595 * 130mm);

                top: calc(297 / 842 * -45mm);
                right: calc(210 / 595 * -124mm);
            }

            .seal {
                height: 100%;
                width: 100%;
            }

            .footer__signature {
                position: absolute;

                height: calc(297 / 842 * 129mm);
                width: calc(210 / 595 * 136mm);

                top: calc(297 / 842 * -17mm);
                right: calc(210 / 595 * -149mm);
            }

            .signature {
                height: 100%;
                width: 100%;
            }

        </style>
    </head>
    <body>
    <div class="page">
        <div class="page__background">
            <img src="${bg}">
        </div>
        <div class="page__content content content__main">
            <div class="content__logo">
                <img class="logo"
                     src="https://e7n.s3.yandex.net/static/certificates/2022-autumn-diag-inf/logo.svg"
                     alt="Яндекс Учебник">
            </div>
            <div class="content__title">
                Благодарственное<br>
                письмо
            </div>
            <div class="content__subtitle">${event}</div>
            <div class="content__personal-info personal-info">
                <div class="personal-info__name name">
                    ${lastName ?? ''}<br>
                    ${firstName ?? ''}<br>
                    ${middleName ?? ''}
                </div>
                <div class="personal-info__school school">
                    ${schoolName ?? ''}
                </div>
            </div>
            <div class="content__description description">
                <div class="description__title">
                    Уважаемый учитель!
                </div>
                <div class="description__text">
                    Спасибо за то, что помогли ученикам<br>
                    проверить их цифровые навыки и<br>
                    способности в области информатики<br>
                    и программирования.
                </div>
            </div>
            <div class="content__footer footer">
                <div class="footer__person person">
                    <div class="person__name">Е.Б. Краевская</div>
                    <div class="person__position">
                        Руководитель сервиса<br>Яндекс Учебник
                    </div>
                </div>
                <div class="footer__date">
                    ${date}
                </div>
                <div class="footer__seal">
                    <img class="seal"
                         src="https://e7n.s3.yandex.net/static/certificates/2022-autumn-diag-inf/yandex-seal.png"
                         alt="печать Яндекс Учебник">
                </div>
                <div class="footer__signature">
                    <img class="signature"
                         src="https://e7n.s3.yandex.net/static/certificates/2022-autumn-diag-inf/signature_kraevaskaya.svg"
                         alt="подпись Краевской">
                </div>
            </div>
        </div>
    </div>
    </body>
    </html>
    `;
};
